module.exports = __webpack_public_path__ + "img/img-classify5.b0da9a3e.png";